/* Built In Imports */
import NextLink from 'next/link';
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
// import CardDonationGroup from '@components/Card/CardDonationGroup';
import DonateFeature from '@landing_pages/donation/components/DonateFeature';

/* Services */
/* Styles */

/**
 * Renders VolunteerSharingTopSliderGroup Component
 *
 * @param {object} sectionContent - Data from api
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns
 */

const DonateFeatureCard = ({ sectionContent, region, lang }) => {
  return (
    <>
      <Box className="donate-featured" m="0 auto 30px auto">
        <Text
          padding={{ base: '10px 0 15px 30px', md: '10px 0 15px 50px' }}
          fontFamily="'FedraSansStd-book', sans-serif"
          fontSize={'28px'}
          fontWeight={'600'}
          color={'#333333'}
          className="feature-heading"
        >
          {sectionContent[0].text}
        </Text>
        {/* <CardDonationGroup
          sectionContent={sectionContent[1]}
          region={region}
          lang={lang}
          sec={'featured'}
        /> */}
        <DonateFeature
          sectionContent={sectionContent[1]}
          region={region}
          lang={lang}
          sec={'featured'}
        />
        <style>
          {`
            .donate-featured .feature-heading {
              padding: 10px 0 15px 50px !important;
            }
            .donate-featured article {
              margin-bottom: 10px !important;
            }
            @media (max-width: 768px) {
             .donate-featured .feature-heading {
                padding: 10px 0 15px 30px !important;
              }
            }
          `}
        </style>
      </Box>
    </>
  );
};

const DonationCard = ({ card, region, lang, setRef, index, groupcard }) => {
  let readLessTxtCount = '';
  if (index == 0) {
    readLessTxtCount = 88;
  } else if (index == 1) {
    readLessTxtCount = 74;
  } else if (index == 2) {
    readLessTxtCount = 79;
  } else if (index == 3) {
    readLessTxtCount = 132;
  } else if (index == 4) {
    readLessTxtCount = 134;
  }
  const [showMore, setShowMore] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = 25;
      const maxHeight = 125; // Max height for 5 lines
      setIsOverflowing(textRef.current.scrollHeight > maxHeight);
    }
  }, []);

  const isLessThen = useMediaQuery({ minWidth: 990 });
  const [show, setShow] = useState(false);
  const [readMoreTxt, setReadMoreTxt] = useState(readLessTxtCount);
  const [txtHide, setTxtHide] = useState(true);
  const descText = render(card?.description);

  const viewText = () => {
    setReadMoreTxt(-1);
    setTxtHide(false);
  };
  const lessText = () => {
    setReadMoreTxt(readLessTxtCount);
    setTxtHide(true);
  };
  const toggleLink = (id, button) => {
    let currentElem = getRef(id)?.current;
    if (currentElem?.className.indexOf('truncate-text-4') > -1) {
      currentElem?.classList.remove('truncate-text-4');
      document.getElementById(button).innerHTML = 'Read Less';
    } else {
      currentElem?.classList.add('truncate-text-4');
      document.getElementById(button).innerHTML = 'Read More...';
    }
  };

  const ctaButton = (buttonText, buttonLink, indx, groupcard) => {
    const icon1 = `${config.imgPath}/d/46272/1741785431-icon-educate-a-child-svg.svg`;
    const icon2 = `${config.imgPath}/d/46272/1741785431-icon-plant-a-tree-svg.svg`;
    const icon3 = `${config.imgPath}/d/46272/1741785431-icon-help-rural-communities-svg.svg`;
    let buttonUrl = '';
    buttonUrl = ShortCodeProcess(buttonLink.toString());
    buttonUrl = parse(buttonUrl);
    return (
      <NextLink
        href={refineUrlDomain(buttonUrl, region, lang)}
        passHref
        legacyBehavior
      >
        <Link
          mb={{ md: '20px', base: '16px' }}
          display="flex"
          justifyContent="center"
          alignItems="center"
          fontWeight={500}
          fontFamily="FedraSansStd-medium"
          fontSize="16px"
          bgColor="orange.50"
          textAlign="center"
          padding="10px"
          borderRadius="3px"
          color="white"
          textDecoration="none"
          _hover={{
            bg: 'blue.50',
          }}
          cursor="pointer"
          width={'290px'}
          m="0 auto"
          height={{ base: '46px', md: '56px' }}
        >
          {!groupcard && (
            <Image
              src={
                indx === 0
                  ? icon1
                  : indx === 1
                  ? icon2
                  : indx === 2
                  ? icon3
                  : ''
              }
              alt=""
              title=""
              pr="5px"
            />
          )}
          {buttonText}
        </Link>
      </NextLink>
    );
  };

  return (
    <>
      <Box
        as="article"
        display="flex"
        flexDir={{ base: 'column', lg: 'column' }}
        bgColor="#F5F5F5"
        borderRadius="5px"
        mb="30px"
        w="320px"
        minH={'550px'}
        mx="auto"
        justifyContent={'space-around'}
      >
        <Box maxW="320px" w="100%">
          <Box
            bgImage={{
              base: card.mobileThumbnail?.url,
              lg: card.thumbnail?.url,
            }}
            bgRepeat="no-repeat"
            bgSize="cover"
            w="320px"
            h={'220px'}
            pos="relative"
          >
            {card.isFeatured && (
              <Box
                pos="absolute"
                bgColor="#CF4520"
                color="#fff"
                top="10px"
                fontSize="16px"
                p="0px 4px 0px 10px"
              >
                Featured
              </Box>
            )}
          </Box>
        </Box>

        <Box
          display="flex"
          flexDir="column"
          p="20px 15px"
          maxW="320px"
          w="100%"
        >
          <Box
            as="h2"
            fontWeight="600"
            height="75px"
            fontFamily="FedraSansStd-book"
            fontSize={{ base: '22px', md: '22px' }}
            display="flex"
            alignItems="center"
            justifyContent="left"
          >
            {card.title}
          </Box>

          <Box
            as="p"
            lineHeight="30px"
            ref={textRef}
            style={{
              maxHeight: showMore ? 'none' : '125px',
              overflow: 'hidden',
            }}
          >
            <StructuredTextParser
              region={region}
              lang={lang}
              str={render(card?.description)}
              className="card_description"
            />
          </Box>
          {isOverflowing && (
            <Box
              color="#CF4520"
              fontSize="16px"
              fontFamily="FedraSansStd-book"
              pt="10px"
              onClick={() => setShowMore(!showMore)}
              cursor="pointer"
              textAlign="left"
              className="readmoreless"
            >
              {showMore ? 'Read Less' : 'Read More'}
            </Box>
          )}
          {card.buttonText && (
            <Box mt="20px">
              {ctaButton(card?.buttonText, card?.buttonLink, index, groupcard)}
            </Box>
          )}
        </Box>
        <style>
          {`
            .card_description {
              font-family: FedraSansStd-book;
              margin-top: 0px;
            }
            .card_description p {
              line-height: 30px;
            }
            @media (max-width: 768px) {
             
            }
          `}
        </style>
      </Box>
    </>
  );
};

export default DonateFeatureCard;
